<template>
  <div class="flex flex-col h-full overflow-y-auto">
    <slot />
  </div>
</template>

<script>
export default {};
</script>
